import moment from 'moment';

export const computeDuration = (
  durationTime: number | null | undefined
): string => {
  const durationInSeconds = durationTime || 0;
  const durationMoment = moment.duration(durationInSeconds, 'seconds');
  const formatString = durationInSeconds >= 3600 ? 'HH:mm:ss' : 'mm:ss';

  return moment.utc(durationMoment.asMilliseconds()).format(formatString);
};

export function formatDuration(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}
